<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "VLAN Profile Config" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current vlan profile config." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'VLAN Profile Config'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="isShowAddTable = true"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                  <div
                  @click="clkEdit()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
                <div
                  @click="clkDel()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th v-for="(value, key) in title" :key="key" :title="value">
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in vlanTable"
                :key="row.profileId"
                :class="{ 'true:': true }"
                @click="changeSelect(row)"
              >
                <td width="40px">
                  <div @click.stop="" v-if="!row.isNew">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelect' + index"
                    />
                    <label :for="'idRowSelect' + index"></label>
                  </div>
                </td>
                <td>
                  <div>{{ row.profileId }}</div>
                </td>
                <td>
                  <div>{{ row.profileName }}</div>
                </td>
                <td>
                  <div
                    @click="clkConfig(row.profileId)"
                    class="btn"
                    :class="{ disabled: false }"
                    style="padding: 0px"
                  >
                    <i class="fa fa-external-link page-tableaction"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="isShowAddTable">
            <dialog-box
              :btitle="'Vlan Profile Edit'"
              @close="clkCancel()"
              style="min-height: 450px"
            >
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="profileId">{{
                    title.profileId
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(1)}">
                    <input
                      type="text"
                      name="profileId"
                      class="form-control"
                      :disabled="isEditClik"
                      v-model="vlanForm.profileId"
                      autocomplete="off"
                      :placeholder=" 'INTEGER<0-' + profileMaxNum + '>'"
                    />
                     <small
                        class="help-block"
                        :style="{
                          display: input_para_check(1) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(1) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="name">{{
                    title.profileName
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(2)}">
                    <input
                      type="text"
                      name="profileName"
                      maxlength="128"
                      class="form-control"
                      v-model="vlanForm.profileName"
                      autocomplete="off"
                      placeholder="STRING<1-128>"
                    />
                     <small
                        class="help-block"
                        :style="{
                          display: input_para_check(2) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(2) }}
                      </small>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>

                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"
import DialogBox from "@/components/DialogBox"
import InfoBox from "./../components/InfoBox.vue"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "profileVlan",
  components: {
    BlockCntr,
    DialogBox,
    InfoBox,
  },

  data() {
    return {
      title: {},
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      select: [],
      vlanForm: {
        profileId: "",
        profileName: "",
      },

      vlanTable: [],
      profileMaxNum:"2047",
    }
  },

  created() {
    this.loadvlanProfile()
    this.loadProfileNum()
  },

  methods: {
    loadvlanProfile() {
      get("profilevlanpri")
        .then((res) => {
          this.vlanTable = res.data.data
          this.title = res.data.title
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadProfileNum() {
      get("profilemaxnum")
        .then((res) => {
          this.profileMaxNum = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      var vlanformTmp = {
        profileId: "",
        profileName: "",
      }

      this.vlanForm = vlanformTmp
    },

    profileSortFun(a, b) {
      return Number(a.profileId) - Number(b.profileId)
    },

    clkEdit() {
      for (let i = 0; i < this.vlanTable.length; i++) {
        if (this.vlanTable[i].selected) {
          this.vlanForm.profileId = this.vlanTable[i].profileId
          if(this.vlanTable[i].profileName.match(/^INDEX_/) == null)
          {
            this.vlanForm.profileName = this.vlanTable[i].profileName
          }
          
          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    clkApply() {
      var newProfile = {
        profileId: Number(this.vlanForm.profileId),
        profileName: this.vlanForm.profileName,
        operate: 1,
      }

      if(this.vlanForm.profileId == "")
      {
        this.showAlertBox(
              "warn",
              "Message",
              "Invalid profileID"
          )
         return 
      }

      var msg = this.input_para_check(0)
      if( msg != null)
      {
          this.showAlertBox(
              "warn",
              "Message",
              msg
          )
          return
      }

      if (!this.isEditClik) {
        for (let i = 0; i < this.vlanTable.length; i++) {
          if (this.vlanTable[i].profileId == newProfile.profileId) {
            this.showAlertBox(
              "warn",
              "Message",
              "this profile id has been existed,please choose a new one"
            )
            return
          }
        }
      }

      post("profilevlanpri", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadvlanProfile()
            /*this.vlanTable.push(newProfile)
            this.vlanTable.sort(this.profileSortFun)*/
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkConfig(value) {
      this.$router.push("profilevlanrule/" + value)
    },

    clkDel() {
      var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        profileId: 0,
        operate: 2,
      }

      for (i = 0; i < this.vlanTable.length; i++) {
        if (this.vlanTable[i].selected) {
          newProfile.profileId = Number(this.vlanTable[i].profileId)
          del.push(post("profilevlanpri", newProfile))
          id.push(this.vlanTable[i].profileId)
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
              for (i = 0; i < this.vlanTable.length; i++) {
                if (this.vlanTable[i].profileId == id[index]) {
                  this.vlanTable.splice(i, 1)
                  break
                }
              }
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
              errflag = 1
            }
          })
          if (errflag === 0)
            this.showAlertBox("info", "Info", "Delete successful!")
        })

        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    changeSelectAll() {
      for (let i = 0; i < this.vlanTable.length; i++) {
        if (this.isSelectAll) {
          this.$set(this.vlanTable[i], "selected", true)
        } else {
          this.$set(this.vlanTable[i], "selected", false)
        }
      }
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    input_para_check(value)
    {
      if(value == 1 || value == 0)
      {
        if(this.vlanForm.profileId != "")
        {
            let profileid = Number(this.vlanForm.profileId)
            if(!isNaN(profileid))
            {
                if(profileid < 0 || profileid > Number(this.profileMaxNum))
                return "profile id must be in range 0-"+ this.profileMaxNum
            }
            else
              return "profile id must be in range 0-"+ this.profileMaxNum
        }
      }

      if(value == 2 || value == 0)
      {
        var space=/[\s]/
        if (space.test(this.vlanForm.profileName)) return "Contains illegal characters."
        else
         return nonASCIIchar(this.vlanForm.profileName)
      }
      return null
    }
  },

  filters: {
    capitalize: function (value) {
      if (value == "1") return "Translate"
      else if (value == "2") return "Add"
      else if (value == "3") return "Tag"
      else if (value == "4") return "Translate&Add"
    },
  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>